var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckThick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic20-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88074 14.1447C4.22173 13.3962 3.15327 13.3962 2.49426 14.1447C1.83525 14.8932 1.83525 16.1068 2.49426 16.8553L10.9318 26.4386C11.6154 27.2151 12.7325 27.1817 13.3793 26.3655L28.5668 7.19886C29.1903 6.41205 29.1341 5.20017 28.4414 4.49204C27.7486 3.78391 26.6816 3.84769 26.0582 4.6345L12.0605 22.2996L4.88074 14.1447Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckThick);
export default __webpack_public_path__ + "static/media/checkThick.bc01853b8d7a57ae588eea6a3a60c8e5.svg";
export { ForwardRef as ReactComponent };